function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n    display: -webkit-box;\n    max-height: ",
        ";\n    overflow: hidden;\n    -webkit-box-orient: vertical;\n    -webkit-line-clamp: ",
        ";\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
import { css } from "styled-components";
import React from "react";
function withLineClamp(height, lines) {
    return css(_templateObject(), height, lines);
}
var getThemedStyle = function(name) {
    return function(lightStyle, darkStyle) {
        return name === "dark" ? darkStyle : lightStyle;
    };
};
export function getThemeUtil(themeName) {
    return {
        /**
     * Helper utility for pairs of theme-specific styles. Prefer using existing
     * theme styles on theme.km, but this is useful for one-offs that are not
     * yet widely adopted in our broader theming strategy.
     *
     * @example
     * const OneOffFoo = styled.div`
     *   border-color: ${p => p.theme.km.util.themedStyle(GREY_900, GREY_50)};
     * `;
     *
     * This will use GREY_900 when the theme is 'light', and GREY_50 when the
     * theme is 'dark'.
     */ themedStyle: getThemedStyle(themeName),
        /**
     * Mixin to truncate text via line clamping. go/mdn/CSS/-webkit-line-clamp
     *
     * @example
     * const ClampedText = styled(Body1)`
     *   ${p => p.theme.km.util.withLineClamp(2, "48px")};
     * `;
     *
     * This will allow 2 lines of text before ellipsis truncation, and set the
     * height of your container to be 48px. An explicit height is required,
     * because clamping works based on overflow behaviors.
     */ withLineClamp: withLineClamp
    };
}
